<script setup lang="ts">
import { GpBtn, GpCard, GpNumberInput, GpTextInput } from '@gportal/uikit';
import ConfirmModal from 'gpcore-uikit/components/new/ConfirmModal.vue';
import ReRegExp from 'reregexp';
import { computed, ref, useAttrs } from 'vue';

defineProps<{
  limit: number;
}>();

const emit = defineEmits<{
  generateNodes: [count: number, formular: string];
}>();

const count = ref(1);

const formula = ref('node([0-9]{4})\\.my\\.domain');
const namesBuildable = computed((): boolean => {
  try {
    new ReRegExp(`/${formula.value}/`).build();
  } catch (e) {
    return false;
  }
  return true;
});

const showConfirmModal = ref(false);
const modalConfirm = () => {
  emit('generateNodes', count.value, formula.value);
  showConfirmModal.value = false;
};

const attrs = useAttrs();
</script>

<template>
  <GpCard
    :class="attrs.class"
    title="Node name generator"
    :enlarge-on-hover="false"
    :border-on-hover="false"
    body-class="tw-p-4"
  >
    <template #content>
      <GpNumberInput
        input-id="fleet-config-count"
        v-model="count"
        name="count"
        :error="count > limit ? `Instance count exceeds node limit, max ${limit} allowed.` : ''"
        :hint="`Current node limit is ${limit}.`"
        label="Instances"
        :min="1"
        :max="limit"
        :step="1"
      />
      <GpTextInput
        class="tw-mt-4"
        label="Regex for name generation"
        v-model="formula"
        :error="
          namesBuildable
            ? ''
            : 'Names cannot be built with this regex. Regex formula for node hostname generation (example: \'([0-9]{4})\' generates 4 random numbers).'
        "
        input-id="fleet-config-generator"
        name="generator"
        hint="Regex formula for node generation (example: '([0-9]{4})' generates 4 random numbers)."
      />
      <GpBtn
        class="tw-mt-4"
        outline
        label="Generate node hostnames"
        @click="showConfirmModal = true"
      />

      <ConfirmModal
        :show="showConfirmModal"
        question="Are you sure you want to generate hostnames? This will overwrite all existing hostnames."
        confirm-text="Generate"
        @close="showConfirmModal = false"
        @confirm="modalConfirm"
      />
    </template>
  </GpCard>
</template>

<style scoped></style>
